<span class="value" [title]="tagNames">{{ tagNames ? tagNames : '&nbsp;' }}</span>
<div class="label" *ngIf="label && tags && tags.length" translate>{{ label }}</div>
